import { Building2, Eye, Video, Heart } from 'lucide-react';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { AdvertiseHero } from '@/components/advertise/AdvertiseHero';
import { AdvertiseBenefitsGrid } from '@/components/advertise/AdvertiseBenefitsGrid';
import { AdvertiseFAQ } from '@/components/advertise/AdvertiseFAQ';
import { ADVERTISE_BUILDERS } from '@/constants/testIds/advertise';

const BENEFITS = [
  { icon: Eye, title: '20x more views', desc: 'Community Boost pages get up to 20x the visibility of an unboosted new-construction listing.' },
  { icon: Video, title: 'Inline 3D tours', desc: 'Showcase floor plans and model homes with embedded Matterport walkthroughs.' },
  { icon: Heart, title: 'More saves & favorites', desc: 'Buyers actively researching new construction save boosted communities far more often.' },
  { icon: Building2, title: 'Built for portfolios', desc: 'Manage every community, market, and home type from a single builder dashboard.' },
];

const FAQS = [
  ['What is Community Boost?', 'A dedicated marketing package for builders — it puts your new-construction communities in front of buyers actively searching your markets, with premium placement and 3D tours.'],
  ['Is pricing per community or per portfolio?', 'Pricing is scoped per community; our team will walk through the right structure for your portfolio on your call.'],
  ['Can I boost communities across multiple markets?', 'Yes — tell us the markets you serve and we\u2019ll tailor a plan that covers your full pipeline.'],
  ['How fast can we get started?', 'Most builders are live within a week of their onboarding call.'],
];

export default function BuildersLanding() {
  const revealRef = useScrollReveal();
  return (
    <div ref={revealRef}>
      <AdvertiseHero
        eyebrow="For builders"
        title="Put new construction in front of active buyers"
        subtitle="Community Boost gives your new-construction communities premium placement, 3D tours, and a dedicated builder dashboard."
        primaryCta={{ label: 'Get started', to: '/advertise/builders/company', testId: ADVERTISE_BUILDERS.landingCta }}
      />

      <section className="bg-sky-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="reveal text-center">
            <h2 className="font-display text-2xl font-semibold text-slate-900 sm:text-3xl">Why builders choose casahom</h2>
          </div>
          <div className="mt-8"><AdvertiseBenefitsGrid items={BENEFITS} columns={4} /></div>
        </div>
      </section>

      <AdvertiseFAQ items={FAQS} />
    </div>
  );
}
